import { useRoutes } from 'react-router-dom';
import PrivateRoute from '@/router/privateRoute';
import Login from '../pages/Login';
import Panel from '@/pages/Panel';
import MainLayout from '@/components/layout/MainLayout';
import Residents from "@/pages/Residents"; // Import the layout

export default function AppRouter() {
    return useRoutes([
        {
            path: '/',
            element: <Login />,
        },
        {
            path: '/panel',
            element: <MainLayout />,
            children: [
                {
                    // Nested route under /panel/:id
                    path: '',
                    element: (
                        <PrivateRoute>
                            <Panel />
                        </PrivateRoute>
                    ),
                },
                {
                    path: 'residents',
                    element: (
                        <PrivateRoute>
                            <Residents />
                        </PrivateRoute>
                    ),

                }
            ],
        },
    ]);
}

